import { styled, css } from 'styled-components';

import { Media } from '../../../theme/Media.tsx';

export interface TableWrapperProps {
  $inner?: boolean;
}

export const TableWrapper = styled.div<TableWrapperProps>`
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;

  ${({ theme, $inner }) =>
    $inner
      ? css`
          border: 1px solid ${theme.colors.grey10_1};
        `
      : theme.shadows.small}
`;

export const TableBody = styled.tbody`
  @media ${Media.xsMax} {
    display: block;
  }
`;

export const TableScrollableWrapper = styled.div<{ $maxHeight?: number }>`
  position: relative;
  overflow-x: auto;
  @media ${Media.smMin} {
    ${({ $maxHeight }) =>
      $maxHeight &&
      css`
        overflow-y: auto;
        max-height: ${$maxHeight}px;
      `}
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate;

  @media ${Media.xsMax} {
    display: flex;
    flex-direction: column;
  }
`;
